import * as v from "valibot";
import { rpcContract } from "../rpc";

const localizedTextSchema = v.record(v.string(), v.string());

const questionnaireOptionSchema = v.object({
  id: v.string(),
  label_i18n: localizedTextSchema,
  position: v.number(),
});

const questionnaireQuestionSchema = v.object({
  id: v.string(),
  text_i18n: localizedTextSchema,
  question_type: v.picklist(["single", "multi"]),
  position: v.number(),
  options: v.array(questionnaireOptionSchema),
});

const questionnairePayloadSchema = v.object({
  id: v.string(),
  title_i18n: localizedTextSchema,
  intro_i18n: localizedTextSchema,
  questions: v.array(questionnaireQuestionSchema),
});

export const getCommunityQuestionnaireRpcContract = rpcContract({
  name: "get-community-questionnaire",
  paramsSchema: v.object({
    community_id: v.string(),
  }),
  resultSchema: v.object({
    questionnaire: v.nullable(questionnairePayloadSchema),
  }),
});

export type GetCommunityQuestionnaireParams = v.InferOutput<
  (typeof getCommunityQuestionnaireRpcContract)["paramsSchema"]
>;
export type GetCommunityQuestionnaireResult = v.InferOutput<
  (typeof getCommunityQuestionnaireRpcContract)["resultSchema"]
>;

export const submitCommunityQuestionnaireResponseRpcContract = rpcContract({
  name: "submit-community-questionnaire-response",
  paramsSchema: v.object({
    questionnaire_id: v.string(),
    community_id: v.string(),
    answers: v.array(
      v.object({
        question_id: v.string(),
        option_ids: v.pipe(v.array(v.string()), v.minLength(1)),
      }),
    ),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type SubmitCommunityQuestionnaireResponseParams = v.InferOutput<
  (typeof submitCommunityQuestionnaireResponseRpcContract)["paramsSchema"]
>;
export type SubmitCommunityQuestionnaireResponseResult = v.InferOutput<
  (typeof submitCommunityQuestionnaireResponseRpcContract)["resultSchema"]
>;

export const dismissCommunityQuestionnaireRpcContract = rpcContract({
  name: "dismiss-community-questionnaire",
  paramsSchema: v.object({
    questionnaire_id: v.string(),
    community_id: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type DismissCommunityQuestionnaireParams = v.InferOutput<
  (typeof dismissCommunityQuestionnaireRpcContract)["paramsSchema"]
>;
export type DismissCommunityQuestionnaireResult = v.InferOutput<
  (typeof dismissCommunityQuestionnaireRpcContract)["resultSchema"]
>;
